<template>
  <div>
    <v-layout wrap class="mb-3" v-if="!isBeacon">
      <v-flex xs8>{{ $t('customer says') }}</v-flex>
      <v-flex xs4 class="text-xs-right">
        <intent-prefill-question
          :isWelcome="isWelcome"
          :isCommentToInbox="isCommentToInbox"
          v-if="!isVerify_slip"
          @onAddPrefill="onAddPrefill"
          @openDailogVerify="openDailogVerify"
        ></intent-prefill-question>
        <v-dialog persistent v-model="dialogVerify">
          <v-card class="pa-2">
            <intent-prefill-verify-slip
              v-if="dialogVerify"
              :dialogVerify.sync="dialogVerify"
              :isVerify_slip.sync="isVerify_slip"
              :isMetaVerifySlip="isMetaVerifySlip"
              :isEventPurchase="isEventPurchase"
              :enableEventPurchase="true"
              :dataVerifySlip.sync="dataVerifySlip"
              @onAddPrefill="onAddPrefill"
              @onAddPrefillMeta="onAddPrefillMeta"
              @onClickVerifySlip="onClickVerifySlip"
              @clearVerify="clearVerify"
            ></intent-prefill-verify-slip>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <template v-if="isVerify_slip">
      <h3 style="color: #000; float: left; margin-top: 10px" v-if="isMetaVerifySlip">
        Basic Slip Verification
      </h3>
      <div class="text-xs-right">
        <v-btn samll icon @click="openDailogVerify(isMetaVerifySlip ? 'meta' : '')">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn samll icon @click="clearToWayVerify">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <template v-if="dataVerifySlip.length">
        <div
          class="form-control intent-item z-border-red pa-3"
          v-for="(item, index) in dataVerifySlip"
          :key="index"
          
        >
          <div
            style="text-align: right; color: #fb8c00"
            v-if="(item.status && item.status === 'pending') || item.id.includes('meta')"
          >
            <small class="mr-2">ยังไม่ได้ยืนยันบัญชีบน META Business Suite</small>
            <i
              class="fas fa-info-circle"
              style="font-size: 20px; vertical-align: middle"
              v-tooltip.top="$t('verify_on_meta')"
            ></i>
          </div>
          <i
            v-if="item.status && item.status === 'verified'"
            class="fas fa-check-circle green--text"
            style="float: right; font-size: 20px"
            v-tooltip.top="$t('Verified by Meta')"
          ></i>
          <template v-if="item.typeAccount && item.typeAccount.value === 'all'">
            <h4>
              {{ $t('bank_name') }} : <span> {{ $t('not_specified_account') }} </span>
            </h4>
          </template>
          <template v-else>
            <v-layout wrap>
              <v-flex xs2>
                <img
                  v-if="item.bankName && item.bankName === 'promptpay'"
                  style="width: 40px"
                  :src="'/static/img/assets/payment/logo_e_wallet/ewallet.png'"
                />
                <img
                  v-else
                  style="width: 40px"
                  :src="
                    getBankName(item.bankName)
                      ? getBankName(item.bankName).image
                      : '/static/img/assets/_global/default-photo.png'
                  "
                />
              </v-flex>
              <v-flex xs10>
                <div>
                  <h4 v-if="item.bankName && item.bankName === 'promptpay'">
                    {{ $t('promptpay') }}
                  </h4>
                  <h4 v-else>
                    {{ $t('bank_name') }} :
                    <span v-if="getBankName(item.bankName)">{{
                      getBankName(item.bankName).name_th
                    }}</span>
                  </h4>
                </div>
                <div style="font-size: 90%">
                  <div>
                    <span> {{ $t(paymentTitleType(item)) }} : </span>
                    <span>
                      <template v-if="item.typeAccount.value === 'meta'">xxxxxx</template
                      >{{ item.bankAccountNo }}</span
                    >
                  </div>
                  <div>
                    <span> {{ $t('receiver_name') }} :</span>
                    <span v-if="isMetaVerifySlip"> {{ item.name }} </span>
                    <template v-else>
                      <template v-if="item.keyword && item.keyword.length > 0">
                        <span v-for="(val, index) in item.keyword" :key="`name_text_${index}`">
                          {{ val.text }}
                          <span v-if="index !== item.keyword.length - 1">,</span></span
                        >
                      </template>
                      <span v-else> -</span>
                    </template>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </template>
        </div>
      </template>
      <div class="meta-slip-error-box" v-else>
        มีบางสิ่งผิดพลาด กรุณาติดต่อเจ้าหน้าที่เพื่อตรวจสอบ
      </div>
      <div style="text-align: right" v-if="isMetaVerifySlip && dataVerifySlip.length">
        <v-btn
          outline
          color="primary"
          @click="
            openLink(
              `https://business.facebook.com/latest/orders/payment_settings?asset_id=${selectedBot.pageid}&nav_ref=add_accounts_slip_verification`
            )
          "
          >{{ $t('confirm_account') }}</v-btn
        >
      </div>
    </template>
    <div v-show="!isVerify_slip">
      <template v-if="!isBeacon">
        <label class="caption" style="margin-bottom: 0px">
          <template>{{ $t('Sentence') }}</template>
        </label>
        <v-modal-help size="1em">
          <div slot="body">
            <div style="padding: 15px">
              <p class="strong">ตัวอย่าง:</p>
              <p>
                ตั้งค่าว่า:
                <span class="strong primary-color">"สอบถามค่าบริการสินค้าหน่อยค่ะ"</span>
                หากลูกค้าพิมพ์มาว่า "สอบถามค่าบริกานจ่ะ" กรณีนี้ถึงแม้ว่า ลูกค้าพิมพ์คำว่า
                <span class="strong primary-color">"บริกาน"</span> ผิด และใช้คำว่า
                <span class="strong primary-color">"จ่ะ"</span>
                แทนคำว่า
                <span class="strong primary-color">"ค่ะ"</span>
                เหมือนที่เราตั้งค่าไว้ บอทก็ยังเข้าใจและตอบกลับได้
              </p>
              <p>
                <span class="underline">Note:</span>
                พิมพ์ประโยคไปได้เยอะๆเพื่อให้บอทตอบได้แม่นยำขึ้น
              </p>
            </div>
          </div>
        </v-modal-help>
        <div class="form-control" :class="{ 'has-error': errorMessage['normal'] != '' }">
          <tags
            style="margin-bottom: 5px"
            v-model="tag"
            :tags="normal"
            @tags-changed="
              (newTags) => {
                normal = newTags
                updateQuestion()
              }
            "
            @before-adding-tag="checkTag('normal', $event)"
            :btnText="$t('Add')"
          ></tags>
          <input type="hidden" v-model="normal" name="tag_normal" :data-vv-as="$t('question')" />
          <span class="text-error" v-show="errorMessage['normal'] != ''">
            <template v-if="errorMessage['normal'] == 'duplicate'">{{
              $t('Duplicate Question')
            }}</template>

            <template v-else-if="errorMessage['normal'] == 'isOtherLanguage'">{{
              $t('supports_only_thai_and_english_languages')
            }}</template>
          </span>
        </div>

        <label class="caption" style="margin-top: 10px">{{ $t('Keyword') }}</label>
        <v-modal-help size="1em">
          <div slot="body">
            <div style="padding: 15px">
              <p class="strong">ตัวอย่างแบบ1:</p>
              <p>
                การเซ็ทแบบคีย์เวิร์ดมีโอกาสผิดพลาดได้ ถ้าเซต
                <span class="strong primary-color">"ค่าบริการ"</span>ไว้ บอทจะดึงประโยคที่มีคำว่า
                <span class="strong primary-color">ค่าบริการ</span>ไปตอบทันที เช่น
                <span class="strong primary-color">ค่าบริการ</span>เท่าไหร่คะ และ
                <span class="strong primary-color">ค่าบริการ</span
                >โปรนี้ต่างจากค่าบริการโปรก่อนยังไงคะ มันจะตอบเหมือนกันทั้งที่จริงๆแล้ว
                มันเป็นคนละความหมาย
              </p>
              <div class="hr" style="margin-bottom: 15px"></div>
              <p class="strong">ตัวอย่างแบบ2:</p>
              <p>
                ตั้งค่าว่า:
                <span class="strong primary-color">"สอบถาม&&สินค้า"</span>
                หากลูกค้าพิมพ์ประโยคที่มีคำว่า
                <span class="strong primary-color">สอบถาม</span> และ
                <span class="strong primary-color">สินค้า</span> อยู่ในประโยคเดียวกัน
                บอทจะตอบตามที่ตั้งค่าทันที
              </p>
              <p><span class="underline">Note:</span> สัญลักษณ์ "&&" หมายถึง "และ"</p>
            </div>
          </div>
        </v-modal-help>

        <div class="form-control" :class="{ 'has-error': errorMessage['keyword'] != '' }">
          <tags
            style="margin-bottom: 5px"
            v-model="tag"
            :tags="keyword"
            @tags-changed="
              (newTags) => {
                keyword = newTags
                updateQuestion()
              }
            "
            @before-adding-tag="checkTag('keyword', $event)"
            :btnText="$t('Add')"
          ></tags>
          <span class="text-error" v-show="errorMessage['keyword'] != ''">
            <template v-if="errorMessage['keyword'] == 'duplicate'">{{
              $t('Duplicate Question')
            }}</template>

            <template v-else-if="errorMessage['keyword'] == 'isOtherLanguage'">{{
              $t('supports_only_thai_and_english_languages')
            }}</template>
          </span>
        </div>

        <label class="caption" style="margin-top: 10px">{{ $t('Exact word') }}</label>
        <v-modal-help size="1em">
          <div slot="body">
            <div style="padding: 15px">
              <p class="strong">ตัวอย่าง:</p>
              <p>
                ตั้งค่าว่า:
                <span class="strong primary-color">"สนใจ"</span>
                ลูกค้าต้องพิมพ์เหมือนคำที่ตั้งค่าไว้เป๊ะๆ บอทถึงจะสามารถตอบได้
                หากลูกค้าตกคำใดคำนึงหรือสะกดผิด บอทจะไม่สามารถตอบได้
              </p>
              <p>
                <b>ยกตัวอย่างการตั้งค่า:</b>
                <!-- <span class="strong primary-color">
              Xสนใจค่ะ&nbsp;&nbsp;Xสนใจครับ&nbsp;&nbsp;
              <i
                class="far fa-check-circle"
                style="color: green"
              ></i>สนใจ
            </span>-->
              </p>
              <table class="table">
                <tr>
                  <th style="width: 25%; color: #d60000">
                    <i class="far fa-times-circle" style="font-size: 1.5em"></i> ตัวอย่างที่ผิด
                  </th>
                  <th style="color: #4ab21e">
                    <i class="far fa-check-circle" style="font-size: 1.5em"></i> ตัวอย่างที่ถูก
                  </th>
                </tr>
                <tr>
                  <td style="color: #d60000">สนใจค่ะ</td>
                  <td style="color: #4ab21e">สนใจ</td>
                </tr>
                <tr>
                  <td style="color: #d60000">สนใจครับ</td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
        </v-modal-help>

        <div class="form-control" :class="{ 'has-error': errorMessage['exactly'] != '' }">
          <tags
            style="margin-bottom: 5px"
            v-model="tag"
            :tags="exactly"
            @tags-changed="
              (newTags) => {
                exactly = newTags
                updateQuestion()
              }
            "
            @before-adding-tag="checkTag('exactly', $event)"
            :btnText="$t('Add')"
          ></tags>
          <span class="text-error" v-show="errorMessage['exactly'] != ''">
            <template v-if="errorMessage['exactly'] == 'duplicate'">{{
              $t('Duplicate Question')
            }}</template>

            <template v-else-if="errorMessage['exactly'] == 'isOtherLanguage'">{{
              $t('supports_only_thai_and_english_languages')
            }}</template>
          </span>
        </div>

        <div class="hr" style="margin-top: 20px"></div>
        <div class="text-xs-center" style="margin: -13px; margin-bottom: 10px">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            @click="onShowAdvance"
            style="position: relative"
          >
            <!-- {{$t('Advanced')}} -->
            <i
              class="fa"
              :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
            ></i>
            <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
          </a>
        </div>

        <div style="margin-top: 5px" v-show="showAdvanced">
          <label class="caption" for>{{ $t('Start with') }}</label>
          <v-modal-help size="1em">
            <div slot="body">
              <div style="padding: 15px">
                <p class="strong">เริ่มต้นด้วยคีย์เวิร์ด(Start with)</p>
                <p>Ex. ใส่เพิ่ม (02) แชทบอทจะเลือกตอบเมื่อลูกค้าพิมพ์เบอร์บ้านขึ้นต้น 02 ทันที</p>
              </div>
            </div>
          </v-modal-help>
          <template v-if="$store.getters.getPackage == 'premium'">
            <div class="form-control" :class="{ 'has-error': errorMessage['startwith'] != '' }">
              <tags
                style="margin-bottom: 5px"
                v-model="tag"
                :tags="startwith"
                @tags-changed="
                  (newTags) => {
                    startwith = newTags
                    updateQuestion()
                  }
                "
                @before-adding-tag="checkTag('startwith', $event)"
                :btnText="$t('Add')"
              ></tags>
              <span class="text-error" v-show="errorMessage['startwith'] != ''">{{
                errorMessage['startwith'] != '' ? $t('Duplicate Question') : ''
              }}</span>
            </div>
          </template>
          <div v-else>
            <ul class="tags pl-0" style="margin-bottom: 5px">
              <li
                class="tag"
                v-for="(question, index) in startwith"
                :key="'normal_question_' + index"
                :class="{ disabled: true }"
              >
                <specialtext :text="question.text"></specialtext>
                <i class="mark fas fa-exclamation-circle"></i>
              </li>
              <li style="display: inline-block; text-align: center; position: relative">
                <v-premium-lock :inline="true" />
              </li>
            </ul>
          </div>

          <label class="caption" for style="margin-top: 10px">{{ $t('End with') }}</label>
          <v-modal-help size="1em">
            <div slot="body">
              <div style="padding: 15px">
                <p class="strong">ลงท้ายด้วยคีย์เวิร์ด(End with)</p>
                <p>Ex. ใส่เพิ่ม (.com) แชทบอทจะตอบเมื่อลูกค้าพิมพ์ลงท้ายด้วย .com ทันที</p>
              </div>
            </div>
          </v-modal-help>
          <template v-if="$store.getters.getPackage == 'premium'">
            <div class="form-control" :class="{ 'has-error': errorMessage['endwith'] != '' }">
              <tags
                style="margin-bottom: 5px"
                v-model="tag"
                :tags="endwith"
                @tags-changed="
                  (newTags) => {
                    endwith = newTags
                    updateQuestion()
                  }
                "
                @before-adding-tag="checkTag('endwith', $event)"
                :btnText="$t('Add')"
              ></tags>
              <span class="text-error" v-show="errorMessage['endwith'] != ''">{{
                errorMessage['endwith'] != '' ? $t('Duplicate Question') : ''
              }}</span>
            </div>
          </template>
          <div v-else>
            <ul class="tags pl-0" style="margin-bottom: 5px">
              <li
                class="tag"
                v-for="(question, index) in endwith"
                :key="'normal_question_' + index"
                :class="{ disabled: true }"
              >
                <specialtext :text="question.text"></specialtext>
                <i class="mark fas fa-exclamation-circle"></i>
              </li>
              <li style="display: inline-block; text-align: center; position: relative">
                <v-premium-lock :inline="true" />
              </li>
            </ul>
          </div>

          <label class="caption" for style="margin-top: 10px">{{ $t('Start and End with') }}</label>
          <v-modal-help size="1em">
            <div slot="body">
              <div style="padding: 15px">
                <p class="strong">
                  เริ่มต้นและลงท้ายด้วยคีย์เวิร์ด(Start and End with) -> (ใส่ คำเริ่ม && คำลงท้าย)
                </p>
                <p>
                  Ex. ใส่เพิ่ม (www&&.com) แชทบอทจะตอบเมื่อลูกค้าพิมพ์ขึ้นต้นด้วย www และจบด้วย .com
                </p>
              </div>
            </div>
          </v-modal-help>
          <template v-if="$store.getters.getPackage == 'premium'">
            <div
              class="form-control"
              :class="{ 'has-error': errorMessage['startandendwith'] != '' }"
            >
              <tags
                style="margin-bottom: 5px"
                v-model="tag"
                :tags="startandendwith"
                @tags-changed="
                  (newTags) => {
                    startandendwith = newTags
                    updateQuestion()
                  }
                "
                @before-adding-tag="checkTag('startandendwith', $event)"
                :btnText="$t('Add')"
              ></tags>
              <span class="text-error" v-show="errorMessage['startandendwith'] != ''">
                <template v-if="errorMessage['startandendwith'] == 'duplicate'">{{
                  $t('Duplicate Question')
                }}</template>
                <template v-else-if="errorMessage['startandendwith'] == 'requiredand'">{{
                  $t('Please type && in between a word (Ex.www&&com)')
                }}</template>
              </span>
            </div>
          </template>
          <div v-else class="mb-3">
            <ul class="tags pl-0" style="margin-bottom: 5px">
              <li
                class="tag"
                v-for="(question, index) in startandendwith"
                :key="'normal_question_' + index"
                :class="{ disabled: true }"
              >
                <specialtext :text="question.text"></specialtext>
                <i class="mark fas fa-exclamation-circle"></i>
              </li>
              <li style="display: inline-block; text-align: center; position: relative">
                <v-premium-lock
                  text="This function is use available from Premium package onwards. Starting at 500 baht/month. Click to upgrade."
                  :inline="true"
                />
              </li>
            </ul>
          </div>
        </div>

        <label v-show="$store.getters.getPackage != 'premium'" class="caption pb-3">
          <i class="fas fa-exclamation-circle"></i>
          {{
            $t(
              'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
            )
          }}
        </label>
      </template>
      <template v-if="isBeacon">
        <label class="caption" style="margin-top: 10px">รูปแบบการส่ง</label>
        <ul class="tags">
          <li v-for="(tag, index) in exactly" :key="'tag_' + index" class="tag">
            {{ tag.text }}
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'
import IntentPrefillQuestion from './IntentPrefillQuestion'
import specialtext from '@/components/elements/specialtext'
import IntentPrefillVerifySlip from './IntentPrefillVerifySlip'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: String,
    },
    isBeacon: {
      type: Boolean,
      default: false,
    },
    isWelcome: {
      type: Boolean,
      default: false,
    },
    isCommentToInbox: {
      type: Boolean,
      default: false,
    },
    isEventPurchase: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isMetaVerifySlip: false,
      dialogVerify: false,
      dataVerifySlip: [],
      isVerify_slip: false,
      showAdvanced: false,
      result: '',
      tag: '',
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],

      errorMessage: {
        normal: '',
        keyword: '',
        exactly: '',
        startwith: '',
        endwith: '',
        startandendwith: '',
      },
    }
  },
  components: {
    Tags,
    IntentPrefillQuestion,
    IntentPrefillVerifySlip,
    specialtext,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
  },
  mounted: async function () {
    const vm = this
    vm.result = vm.value
    await vm.formatData(vm.value)
    if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.bank_info')) {
      try {
        vm.isVerify_slip = true
        const textSplitValue = vm.normal[0].text.split('{verify_slip.bank_info=')
        const textSplitValue2 = textSplitValue[1].split(',')
        const textValue = textSplitValue2[0].split('^')
        textValue[textValue.length - 1] = textValue[textValue.length - 1].split('}')[0]
        textValue.map((item, index) => {
          let typeAccount = null
          if (item.split('|')[0] === 'promptpay') {
            typeAccount = { value: 'promptpay', label: 'Promptpay' }
          } else if (item.split('|')[0].includes('ew')) {
            typeAccount = { value: 'eWallet', label: 'E-Wallet' }
          } else if (item.split('|')[0].includes('pg') || item.split('|')[0] === 'pgother') {
            typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
          } else {
            typeAccount = { value: 'transfer', label: 'Transfer' }
          }

          let keyword = []
          if (item.split('|') && item.split('|')[2]) {
            item
              .split('|')[2]
              .split('!')
              .forEach((element) => {
                keyword.push({ text: element })
              })
          }
          vm.dataVerifySlip.push({
            id: `${dayjs().format('x')}_${index}`,
            typeAccount: typeAccount,
            bankAccountNo: item.split('|')[1],
            bankName: item.split('|')[0],
            keyword: keyword,
          })
        })
      } catch (error) {
        console.error(error)
      }
    } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.image}')) {
      vm.isVerify_slip = true
      vm.dataVerifySlip[0] = {
        id: dayjs().format('x'),
        typeAccount: { value: 'all', label: 'All' },
        bankAccountNo: '',
        bankName: '',
        keyword: '',
      }
    } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{meta_pay_verified}')) {
      vm.isVerify_slip = true
      vm.isMetaVerifySlip = true
      vm.dataVerifySlip = vm.$store.state.metaVerifySlip
    }
  },
  methods: {
    openLink(link) {
      window.open(link, '_blank')
    },
    openDailogVerify(type) {
      const vm = this
      if (type == 'meta') {
        vm.isMetaVerifySlip = true
      } else {
        vm.isMetaVerifySlip = false
      }
      vm.dialogVerify = true
    },
    async clearToWayVerify() {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('delete_payment_method'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true,
      })
      if (result.value) {
        vm.clearVerify()
      }
    },
    paymentTitleType(item) {
      if (item.bankName && item.bankName === 'transfer') {
        return 'bank_account'
      } else if (item.bankName && item.bankName === 'promptpay') {
        return 'promptpay_code'
      } else if (item.typeAccount && item.typeAccount.value === 'eWallet') {
        return 'E-Wallet ID'
      } else if (item.typeAccount && item.typeAccount.value === 'paymentGateway') {
        return 'Biller ID'
      } else {
        return 'bank_account_no'
      }
    },
    async clearVerify() {
      const vm = this
      vm.dataVerifySlip = []
      vm.normal = []
      vm.isVerify_slip = false
      vm.isMetaVerifySlip = false
      vm.$emit('onClickClearVerifySlip')
    },
    getBankName(bankName) {
      const vm = this
      let bankAlltype = vm.$store.state.bankForVerify.concat(vm.$store.state.eWalletForVerify)
      bankAlltype = bankAlltype.concat(vm.$store.state.paymentGateway)
      return bankAlltype.filter((bankInfo) => bankInfo.value === bankName)[0]
    },
    onClickVerifySlip({ eventPurchase }) {
      const vm = this
      vm.$emit('onClickVerifySlip', { eventPurchase })
      vm.isVerify_slip = true
    },
    onAddPrefillMeta: function (payload) {
      const vm = this
      if (vm.isMetaVerifySlip) {
        vm.normal = []
        vm.keyword = []
        vm.exactly = []
        vm.startwith = []
        vm.endwith = []
        vm.startandendwith = []
        vm.normal = [{ text: '{meta_pay_verified}' }]
      }
      vm.dataVerifySlip = payload
    },
    onAddPrefill: function (payload) {
      const vm = this
      if (vm.isVerify_slip) {
        vm.normal = []
        vm.keyword = []
        vm.exactly = []
        vm.startwith = []
        vm.endwith = []
        vm.startandendwith = []
        vm.normal = [{ text: payload }]
      } else {
        vm.normal.push({ text: payload })
      }
      vm.dataVerifySlip = []
      if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.bank_info')) {
        try {
          const textSplitValue = vm.normal[0].text.split('{verify_slip.bank_info=')
          const textSplitValue2 = textSplitValue[1].split(',')
          const dataValue = textSplitValue2[0].split('^')
          dataValue[dataValue.length - 1] = dataValue[dataValue.length - 1].split('}')[0]
          dataValue.map((item, index) => {
            let typeAccount = null
            if (item.split('|')[0] === 'promptpay') {
              typeAccount = { value: 'promptpay', label: 'Promptpay' }
            } else if (item.split('|')[0].includes('ew')) {
              typeAccount = { value: 'eWallet', label: 'E-Wallet' }
            } else if (item.split('|')[0].includes('pg') || item.split('|')[0] === 'pgother') {
              typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
            } else {
              typeAccount = { value: 'transfer', label: 'Transfer' }
            }
            let keyword = []
            if (item.split('|') && item.split('|')[2]) {
              item
                .split('|')[2]
                .split('!')
                .forEach((element) => {
                  keyword.push({ text: element })
                })
            }
            vm.dataVerifySlip.push({
              id: `${dayjs().format('x')}_${index}`,
              typeAccount: typeAccount,
              bankAccountNo: item.split('|')[1],
              bankName: item.split('|')[0],
              keyword: keyword,
            })
          })
        } catch (error) {
          console.error(error)
        }
      } else if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.image}')) {
        vm.dataVerifySlip[0] = {
          id: dayjs().format('x'),
          typeAccount: { value: 'all', label: 'All' },
          bankAccountNo: '',
          bankName: '',
          keyword: [],
        }
      }
    },
    onShowAdvance: function () {
      this.showAdvanced = !this.showAdvanced
      // if (this.$store.getters.getPackage === 'premium') {
      // }
    },
    checkTag(type, obj) {
      this.errorMessage[type] = ''
      if (obj.tag.isDuplicate) {
        this.errorMessage[type] = 'duplicate'
        obj.error()
      } else if (type === 'startandendwith' && obj.tag.text.split('&&').length - 1 !== 1) {
        this.errorMessage[type] = 'requiredand'
        obj.error()
      } else if (obj.tag.isOtherLanguage) {
        this.errorMessage[type] = 'isOtherLanguage'
        obj.error()
      } else obj.addTag()
    },
    formatData: function (text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.map(function (question, index) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({ text: keyword })
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword })
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({ text: keyword })
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword })
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({ text: keyword })
          } else {
            vm.normal.push({ text: question })
          }
        })
      }
    },
    updateQuestion: function () {
      this.result = ''
      var result = []
      var normal = []
      this.normal.map(function (key, index) {
        normal.push(key.text.replace('เเ', 'แ').trim())
      })
      if (normal && normal.length > 0) {
        result.push(normal.join(','))
      }

      var keyword = []
      this.keyword.map(function (key, index) {
        keyword.push('includes(' + key.text.replace('เเ', 'แ').trim() + ')')
      })
      if (keyword && keyword.length > 0) {
        result.push(keyword.join(','))
      }

      var exactly = []
      this.exactly.map(function (key, index) {
        exactly.push('exacts(' + key.text.replace('เเ', 'แ').trim() + ')')
      })
      if (exactly && exactly.length > 0) {
        result.push(exactly.join(','))
      }

      var startwith = []
      this.startwith.map(function (key, index) {
        startwith.push('startswith(' + key.text.replace('เเ', 'แ').trim() + ')')
      })
      if (startwith && startwith.length > 0) {
        result.push(startwith.join(','))
      }

      var endwith = []
      this.endwith.map(function (key, index) {
        endwith.push('endswith(' + key.text.replace('เเ', 'แ').trim() + ')')
      })
      if (endwith && endwith.length > 0) {
        result.push(endwith.join(','))
      }

      var startandendwith = []
      this.startandendwith.map(function (key, index) {
        startandendwith.push('startsendswith(' + key.text.replace('เเ', 'แ').trim() + ')')
      })
      if (startandendwith && startandendwith.length > 0) {
        result.push(startandendwith.join(','))
      }

      //   this.result = result.join(',')
      this.$emit('input', result.join(','))
    },
  },
  watch: {
    value: function () {
      this.result = this.value
      this.formatData(this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.meta-slip-error-box {
  border: 1px solid;
  border-radius: 10px 10px 10px 0;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentQuestion.vue